export const FETCH_TOOLTIP_REQUEST = 'FETCH_TOOLTIP_REQUEST';
export const FETCH_TOOLTIP_SUCCESS = 'FETCH_TOOLTIP_SUCCESS';
export const FETCH_TOOLTIP_ERROR   = 'FETCH_TOOLTIP_ERROR';

export const UPDATE_TOOLTIP_REQUEST = 'UPDATE_TOOLTIP_REQUEST';
export const UPDATE_TOOLTIP_SUCCESS = 'UPDATE_TOOLTIP_SUCCESS';
export const UPDATE_TOOLTIP_ERROR   = 'UPDATE_TOOLTIP_ERROR';